/* global axios */
import ApiClient from './ApiClient';

class WidgetAppearanceAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  bannersUrl(inboxId) {
    return `${this.baseUrl()}/inboxes/${inboxId}/chat_banners`;
  }

  getBanners(inboxId) {
    return axios.get(this.bannersUrl(inboxId));
  }

  createBanner(inboxId, data) {
    return axios.post(this.bannersUrl(inboxId), data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  updateBanner(inboxId, bannerId, data) {
    return axios.patch(`${this.bannersUrl(inboxId)}/${bannerId}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  deleteBanner(inboxId, bannerId) {
    return axios.delete(`${this.bannersUrl(inboxId)}/${bannerId}`);
  }

  deleteBannerImage(inboxId, bannerId) {
    return axios.delete(`${this.bannersUrl(inboxId)}/${bannerId}/image`);
  }

  reorderBanners(inboxId, bannerIds) {
    return axios.post(`${this.bannersUrl(inboxId)}/reorder`, {
      banner_ids: bannerIds,
    });
  }

  updateLauncherIcon(inboxId, file) {
    const formData = new FormData();
    formData.append('launcher_icon', file);
    return axios.post(
      `${this.baseUrl()}/inboxes/${inboxId}/launcher_icon`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }

  deleteLauncherIcon(inboxId) {
    return axios.delete(`${this.baseUrl()}/inboxes/${inboxId}/launcher_icon`);
  }
}

export default new WidgetAppearanceAPI();
